import React from 'react';
import { LandingPlan } from '../plansData';

const CignaMark: React.FC = () => (
  <img
    src="/images/cigna-logo.svg"
    alt="Cigna"
    className="h-7 w-auto"
  />
);

const Row: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex items-start justify-between gap-3 py-0.5 last:border-b-0">
    <span className="text-[13px] text-[#6B6F77]">{label}</span>
    <span className="text-right text-[13px] font-semibold text-[#23262C]">
      {value}
    </span>
  </div>
);

const Group: React.FC<{ title: string; children: React.ReactNode, className?: string }> = ({
  title,
  children,
  className = '',
}) => (
  <div className={`mt-2 pb-2 border-b border-[#f5eee2] ${className}`}>
    <p className="text-[13px] font-bold text-[#23262C]">{title}</p>
    {children}
  </div>
);

export const PlanCard: React.FC<{ plan: LandingPlan; className?: string }> = ({
  plan,
  className = '',
}) => {
  return (
    <div
      className={`w-full rounded-2xl border border-[#E6E0D4] bg-[#fdf9f0] p-5 shadow-sm ${className}`}
    >
      <div className='flex items-start gap-3 pb-2'>
        <CignaMark />
        <div className=''>
          <h3 className="!font-['Inter'] text-lg sm:text-xl font-semibold">{plan.name}</h3>
          <p className="!min-h-[72px] !font-['Inter'] font-light text-[13px] sm:text-md leading-snug">
            {plan.description}
          </p>
        </div>
      </div>

      <Group title="General Information" className="pt-2 border-t border-[#f5eee2]">
        <Row label="Network Type" value={plan.networkType} />
        <Row label="Office visit copay" value={plan.primaryCopay} />
        <Row label="Specialist copay" value={plan.specialistCopay} />
      </Group>

      <Group title="Deductible – In Network">
        <Row label="Individual" value={plan.deductibleIn.individual} />
        <Row label="Family" value={plan.deductibleIn.family} />
      </Group>

      <Group title="Deductible – Out-of-Network">
        <Row label="Individual" value={plan.deductibleOut.individual} />
        <Row label="Family" value={plan.deductibleOut.family} />
      </Group>

      <Group title="Out-of-Pocket Maximum – In Network">
        <Row label="Individual" value={plan.oopIn.individual} />
        <Row label="Family" value={plan.oopIn.family} />
      </Group>

      <Group title="Out-of-Pocket Maximum – Out-of-Network">
        <Row label="Individual" value={plan.oopOut.individual} />
        <Row label="Family" value={plan.oopOut.family} />
      </Group>

      <Group title="Drug Copay – In Network">
        <Row label="Generic" value={plan.drugGeneric} />
        <Row label="Preferred Brand Drugs" value={plan.drugPreferred} />
      </Group>
    </div>
  );
};
